import CallError from '../../utils/CallError';
import { settings } from '../common/staticData';

export default async (_params = {}, signal = null) => {
  if (!settings.endpoint) {
    throw new CallError('params', {}, 400, { message: 'Missing value for app integrations endpoint' });
  }
  let content;
  const response = await fetch(`${settings.endpoint}/get-app-integrations`, {
    signal,
  });
  const data = await response.text();
  try {
    content = JSON.parse(data);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  }

  return content;
};
